import React, { ReactNode } from 'react';

import { Control } from 'react-hook-form';

import { PersonalDataForm } from './PersonalDataForm/PersonalDataForm';
import { AdditionalInfoForm } from './AdditionalInfoForm/AdditionalInfoForm';
import { AddressDataFrom } from './AddressDataFrom/AddressDataFrom';
import { CombinedCustomerInfo } from '../../interfaces/Customer';
import { CustomerProfileFormMode } from './CustomerProfileForm.settings';
import { Option } from '../../../general-types';
import { InbodyInfoForm } from './InbodyInfoForm/InbodyInfoForm';

type CustomerProfileFormProps = {
  control: Control<CombinedCustomerInfo>;
  mode: CustomerProfileFormMode;
  entityId: number;
  defaultValues: CombinedCustomerInfo | null;
  supportedInbodyTypeOptions?: Option[];
  InbodyInfoFormChildren?: ReactNode;
};

const CustomerProfileForm = ({
  control,
  mode,
  entityId,
  defaultValues,
  supportedInbodyTypeOptions,
  InbodyInfoFormChildren,
}: CustomerProfileFormProps) => {
  return (
    <>
      <InbodyInfoForm
        mode={mode}
        control={control}
        supportedInbodyTypeOptions={supportedInbodyTypeOptions}
      >
        {InbodyInfoFormChildren}
      </InbodyInfoForm>
      <PersonalDataForm control={control} entityId={entityId} />
      <AdditionalInfoForm
        control={control}
        entityId={entityId}
        defaultSchoolId={defaultValues?.additionallyInfo.schoolId}
      />
      <AddressDataFrom control={control} />
    </>
  );
};

export { CustomerProfileForm };
